import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * LOCALES notification formatter
 * Extends notification with locale details based on action type
 */
export default class LocaleFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const payload = notification.payload
    const action = payload?.action
    const id = payload?.id
    const localeCode = payload?.localeCode

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = []

    // Add a locale name if available
    if (payload?.name) {
      additionalParams.push({
        key: 'locale_name',
        values: { name: payload.name }
      })
    }

    // Add locale code if available
    if (payload?.code) {
      additionalParams.push({
        key: 'locale_code',
        values: { code: payload.code }
      })
    }

    // Add country code if available
    if (payload?.countryCode) {
      additionalParams.push({
        key: 'locale_country_code',
        values: { countryCode: payload.countryCode }
      })
    }

    // Add full code if available
    if (payload?.fullCode) {
      additionalParams.push({
        key: 'locale_full_code',
        values: { fullCode: payload.fullCode }
      })
    }

    // For DELETE action, use localeCode if fullCode is not present
    if (action === 'DELETE' && localeCode && !payload?.fullCode) {
      additionalParams.push({
        key: 'locale_full_code',
        values: { fullCode: localeCode }
      })
    }

    // Determine a link based on the action
    let link: string | undefined

    if (action === 'CREATE' || action === 'UPDATE') {
      // For CREATE and UPDATE, link to locale detail if id is available
      link = id ? `/localization/locales/${id}` : undefined
    }

    return {
      ...notification,
      additionalParams,
      link
    }
  }
}
